module.exports = __webpack_public_path__ + "ir.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ir.svg
// module id = 618
// module chunks = 0